import { IntegrationProvider, SegmentTemplateType } from "@api/types";

export const INTEGRATION_PROVIDERS: IntegrationProvider[] = [
  {
    name: "Mariana Tek",
    category: "CRM",
    description: "Import and message your Xplor Mariana Tek contacts.",
    logo: "/images/integrations/mariana-tek/icon.png",
    url: "https://www.marianatek.com/",
    id: "mariana-tek",
    features: [
      "Imports all existing clients from Mariana Tek into Helios",
      "Imports and updates clients from Mariana Tek in real time",
      "Report conversions from Helios conversations",
    ],
    requirements: ["Valid and current Mariana Tek account"],
  },
  {
    name: "Mindbody",
    category: "CRM",
    description: "Import and message your Mindbody clients.",
    logo: "/images/integrations/mindbody/icon.png",
    url: "https://www.mindbodyonline.com",
    id: "mindbody",
    features: [
      "Imports all existing clients from Mindbody into Helios",
      "Imports and updates clients from Mindbody in real time",
      "Report conversions from Helios conversations",
    ],
    requirements: ["Valid and current Mindbody account", "Valid and active Mindbody SiteID"],
  },
  {
    name: "Fitdegree",
    category: "CRM",
    description: "Import and message your Fitdegree contacts.",
    logo: "/images/integrations/fitdegree/icon.png",
    url: "https://www.fitdegree.com",
    id: "fitdegree",
    features: [
      "Imports all existing clients from Fitdegree into Helios",
      "Imports and updates clients from Fitdegree in real time",
      "Report conversions from Helios conversations",
    ],
    requirements: ["Valid and current Fitdegree account"],
  },
  {
    name: "Zenoti",
    category: "CRM",
    description: "Connect a Zenoti center to this location.",
    logo: "/images/integrations/zenoti/icon.png",
    url: "https://www.zenoti.com",
    id: "zenoti",
    features: ["Connects one Zenoti center to this location with your organization API key"],
    requirements: [
      "Zenoti organization API key (Configuration > Integrations > Apps, app type Organization)",
    ],
    unlisted: true,
  },
  {
    name: "ActiveCampaign",
    category: "CRM",
    description: "Import and message your ActiveCampaign contacts.",
    logo: "/images/active-campaign-glyph.png",
    url: "https://www.activecampaign.com",
    id: "active-campaign",
    features: [
      "Imports all existing clients from ActiveCampaign into Helios",
      "Imports new clients from ActiveCampaign in real time",
    ],
    requirements: ["Valid and current ActiveCampaign account"],
  },
  {
    name: "Hubspot",
    category: "CRM",
    description: "Sync contacts and leads with your Hubspot account.",
    logo: "/images/integrations/hubspot/icon.svg",
    url: "https://www.hubspot.com",
    id: "hubspot",
    features: [
      "Imports all existing contacts from Hubspot into Helios",
      "Imports and updates leads from Hubspot in real time",
      "Report conversions from Helios conversations",
    ],
    requirements: ["Valid and current Hubspot account"],
  },
  {
    name: "Tablelist",
    category: "CRM",
    description: "Import and message your Tablelist clients.",
    logo: "https://i.ibb.co/Pm2RsJ9/tablelist.png",
    url: "https://www.tablelistpro.com",
    id: "tablelist",
    features: [
      "Imports all existing clients from Tablelist into Helios",
      "Imports new clients from Tablelist in real time",
      "Report conversions from Helios conversations",
    ],
    requirements: ["Valid and current TablelistPro account"],
  },

  {
    name: "Square",
    category: "POS",
    description: "Import and message your Square contacts.",
    logo: "/images/integrations/square/icon.png",
    url: "https://squareup.com",
    id: "square",
    features: [
      "Imports all existing clients from Square into Helios",
      "Imports and updates clients from Square in real time",
      "Report conversions from Helios conversations",
    ],
    requirements: ["Valid and current Square account"],
  },
  {
    name: "Shopify",
    category: "eCommerce",
    description: "Import and message your Shopify contacts.",
    logo: "/images/integrations/shopify/icon.png",
    url: "https://www.shopify.com/",
    id: "shopify",
    features: [
      "Imports all existing clients from Shopify into Helios",
      "Imports and updates clients from Shopify in real time",
      "Report conversions from Helios conversations",
    ],
    requirements: ["Valid and current Shopify account"],
  },
  {
    name: "Gymble",
    category: "CRM",
    description: "Import and message your Gymble clients.",
    logo: "/images/integrations/gymble/icon.png",
    url: "https://www.gymble.us",
    id: "gymble",
    features: [
      "Imports all existing clients from Gymble into Helios",
      "Imports new clients from Gymble in real time",
    ],
    requirements: ["Valid and current Gymble account", "API key from Gymble dashboard"],
  },
  {
    name: "Webhook",
    category: "Data",
    description: "Import contacts from a JavaScript SDK or Backend API.",
    logo: "https://i.ibb.co/DKMjnht/webhooks-logo-png-transparent.png",
    url: "https://sendhelios.com/help-center/integrations/webhook-sdk",
    id: "webhook",
    features: [
      "Import contacts using a client side JavaScript SDK",
      "Import contacts from a 3rd party webhook provider",
    ],
    requirements: ["Ability to send HTTP requests"],
  },
  {
    name: "Helios",
    category: "hidden",
    description: "",
    logo: "/images/integrations/helios/icon.png",
    url: "https://sendhelios.com/help-center",
    id: "helios",
    features: [],
    requirements: [],
  },
];
const MINDBODY_INTEGRATION_PROVIDER = <IntegrationProvider>(
  INTEGRATION_PROVIDERS.find((i) => i.id === "mindbody")
);
const _MARIANATEK_INTEGRATION_PROVIDER = <IntegrationProvider>(
  INTEGRATION_PROVIDERS.find((i) => i.id === "mariana-tek")
);
const TABLELIST_INTEGRATION_PROVIDER = <IntegrationProvider>(
  INTEGRATION_PROVIDERS.find((i) => i.id === "tablelist")
);
const _WEBHOOK_INTEGRATION_PROVIDER = <IntegrationProvider>(
  INTEGRATION_PROVIDERS.find((i) => i.id === "webhook")
);
const HELIOS_INTEGRATION_PROVIDER = <IntegrationProvider>(
  INTEGRATION_PROVIDERS.find((i) => i.id === "helios")
);

export const INTEGRATION_JOB_TYPES: any = Object.freeze({
  hubspot_client_ingest: "Import Clients",
  shopify_client_ingest: "Import Clients",
  mindbody_client_ingest: "Import Clients",
  mindbody_client_detail_ingest: "Refresh Client",
  mindbody_catalog_ingest: "Import Catalog",
  mindbody_event_ingest: "Import Schedule",
  mindbody_entitlement_refresh: "Refresh Memberships & Passes",
  mindbody_entitlement_backfill: "Backfill Memberships & Passes",
  mindbody_visit_resolution: "Resolve Visits",
  mindbody_visit_backfill: "Backfill Visits",
  mindbody_sale_reconcile: "Reconcile Sales",
  mariana_tek_client_ingest: "Import Clients",
  mariana_tek_system_setup: "System Setup",
  mariana_tek_order_ingest: "Import Orders",
  mariana_tek_membership_ingest: "Import Memberships",
  active_campaign_client_ingest: "Import Clients",
  gymble_client_ingest: "Import Clients",
  tablelist_client_ingest: "Import Clients",
  fitdegree_client_ingest: "Import Clients",
  zenoti_guest_ingest: "Import Guests",
  zenoti_history_ingest: "Import Guest History",
  zenoti_activity_sync: "Sync Activity",
  zenoti_system_setup: "System Setup",
});

export const MINDBODY_SEGMENT_TEMPLATES: SegmentTemplateType[] = [
  {
    id: "recent-first-visit",
    title: "Recent first visit",
    description: "Mindbody clients with a recent first visit.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Recent first visit",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.first_attended_at",
            type: "date",
            operators: [
              {
                op: "$last",
                value: {
                  $now: {
                    duration_unit: "months",
                    duration_value: "7",
                  },
                },
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "single-visit",
    title: "Took first class but haven’t returned",
    description: "Mindbody clients who attended one class and have not booked another.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Took first class but haven’t returned",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.attended_class_count",
            type: "number",
            operators: [
              {
                op: "$eq",
                value: 1,
              },
            ],
          },
        },
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.booked_class_count",
            type: "number",
            operators: [
              {
                op: "$lte",
                value: 1,
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "non-members",
    title: "Non members",
    description: "Mindbody clients with status of non-member.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Non members",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.Status",
            type: "enum",
            operators: [
              {
                op: "$eq",
                value: "Non-Member",
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "churned-memberships",
    title: "Churned members",
    description: "Mindbody clients with a recently ended membership.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Churned members",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.contracts.end_date",
            type: "date",
            operators: [
              {
                op: "$last",
                value: {
                  $now: {
                    duration_unit: "days",
                    duration_value: "30",
                  },
                },
              },
            ],
          },
        },
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.active_membership",
            type: "boolean",
            operators: [
              {
                op: "$ne",
                value: "true",
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "active-members",
    title: "Active members",
    description: "Mindbody clients with status of active.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Active members",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.active_membership",
            type: "boolean",
            operators: [
              {
                op: "$eq",
                value: "true",
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "active-members-not-autopay",
    title: "Active members without autopay",
    description: "Mindbody clients with an active membership not enrolled in autopay.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Active members not enrolled in autopay",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.active_membership",
            type: "boolean",
            operators: [
              {
                op: "$eq",
                value: "true",
              },
            ],
          },
        },
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.contracts.autopay_status",
            type: "enum",
            operators: [
              {
                op: "$ne",
                value: "Active",
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "expiring-memberships",
    title: "Memberships ending soon",
    description: "Mindbody clients with an upcoming membership end date.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Memberships ending soon",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.contracts.end_date",
            type: "date",
            operators: [
              {
                op: "$next",
                value: {
                  $now: {
                    duration_unit: "days",
                    duration_value: "30",
                  },
                },
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "intro-ending-soon",
    title: "Intro offer ending soon",
    description: "Mindbody clients whose intro offer ends in the next 7 days without a purchase.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Intro offer ending soon",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.intro_offer_ends_at",
            type: "date",
            operators: [
              {
                op: "$next",
                value: {
                  $now: {
                    duration_unit: "days",
                    duration_value: "7",
                  },
                },
              },
            ],
          },
        },
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.intro_converted",
            type: "boolean",
            operators: [
              {
                op: "$ne",
                value: "true",
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "intro-expired-no-conversion",
    title: "Intro expired without converting",
    description: "Mindbody clients whose intro offer ended recently without a purchase.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Intro expired without converting",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.intro_offer_ends_at",
            type: "date",
            operators: [
              {
                op: "$last",
                value: {
                  $now: {
                    duration_unit: "days",
                    duration_value: "30",
                  },
                },
              },
            ],
          },
        },
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.intro_converted",
            type: "boolean",
            operators: [
              {
                op: "$ne",
                value: "true",
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "class-card-holders",
    title: "Class pack holders",
    description: "Mindbody clients with class pack sessions remaining and no membership.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Class pack holders",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.pass_sessions_remaining",
            type: "number",
            operators: [
              {
                op: "$gte",
                value: 1,
              },
            ],
          },
        },
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.active_membership",
            type: "boolean",
            operators: [
              {
                op: "$ne",
                value: "true",
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "annual-members",
    title: "Annual members",
    description: "Mindbody clients with an active annual contract.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Annual members",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.annual_membership",
            type: "boolean",
            operators: [
              {
                op: "$eq",
                value: "true",
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "attended-recently",
    title: "Attended in the last 30 days",
    description: "Mindbody clients who took a class in the last 30 days.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Attended in the last 30 days",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.last_attended_at",
            type: "date",
            operators: [
              {
                op: "$last",
                value: {
                  $now: {
                    duration_unit: "days",
                    duration_value: "30",
                  },
                },
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
  {
    id: "purchased-recently",
    title: "Purchased in the last 30 days",
    description: "Mindbody clients with a purchase in the last 30 days.",
    integrationProvider: MINDBODY_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Purchased in the last 30 days",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.mindbody.last_purchase_at",
            type: "date",
            operators: [
              {
                op: "$last",
                value: {
                  $now: {
                    duration_unit: "days",
                    duration_value: "30",
                  },
                },
              },
            ],
          },
        },
      ],
      conditions: [],
      events: [],
    },
  },
];
export const TABLELIST_SEGMENT_TEMPLATES: SegmentTemplateType[] = [
  {
    id: "upcoming-birthday",
    title: "Upcoming Birthday",
    description: "Tablelist customers with a birthday in the next 2 weeks.",
    integrationProvider: TABLELIST_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Has birthday in next 2 weeks",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.tablelist.birthdayOrdinal",
            type: "number",
            operators: [
              {
                op: "$next",
                value: {
                  $lte: {
                    $ordinal: 14,
                  },
                },
              },
            ],
          },
        },
      ],
      events: [],
      conditions: [],
    },
  },
  {
    id: "total-spend",
    title: "Total Spend Amount",
    description: "Tablelist customers with total spend amount.",
    integrationProvider: TABLELIST_INTEGRATION_PROVIDER,
    initialValues: {
      name: "Total Spend greater than {$X}",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "properties.tablelist.stats.totalSpend",
            type: "number",
            operators: [
              {
                op: "$gte",
                value: 0,
              },
            ],
          },
        },
      ],
      events: [],
      conditions: [],
    },
  },
];

export const HELIOS_SEGMENT_TEMPLATES: SegmentTemplateType[] = [
  {
    id: "all-contacts",
    title: "All Contacts",
    description: "Send a message to all of your contacts.",
    integrationProvider: HELIOS_INTEGRATION_PROVIDER,
    initialValues: {
      name: "All contacts",
      type: "dynamic",
      rules: [
        {
          type: "condition",
          rule: {
            key: "phoneNumber",
            type: "string",
            operators: [
              {
                op: "$exists",
                value: "true",
              },
            ],
          },
        },
      ],
      events: [],
      conditions: [],
    },
  },
];

export const SEGMENT_TEMPLATES: Partial<Record<string, SegmentTemplateType[]>> = {
  helios: HELIOS_SEGMENT_TEMPLATES,
  mindbody: MINDBODY_SEGMENT_TEMPLATES,
  tablelist: TABLELIST_SEGMENT_TEMPLATES,
  zenoti: [],
  "active-campaign": [],
  "mariana-tek": [],
  shopify: [],
  hubspot: [],
  webhook: [],
  gymble: [],
  fitdegree: [],
};
